import memberQuery from './member-query.js'
import jcTong from './jc_tong'
import wallet from './wallet'
import statistics from './statistics'
import bank from './bank'
import orgAnalysis from './org-analysis'
import orgMember from './org-query'
import integral from './integral'
import memberExit from './member-quit'
export default {
  memberQuery,
  jcTong,
  wallet,
  statistics,
  bank,
  orgAnalysis,
  orgMember,
  integral,
  memberExit
}



// WEBPACK FOOTER //
// ./src/api/apis/member/index.js